import { ROLES_NAME_TO_ID } from '@/pages/agency/permission-config';

/**
 * 多个权限任选一个
 * @param perm
 * @return {*}
 */
export const oneOf = (perm: any) => {
  if (!perm) {
    return undefined;
  }
  return (loginStatus: Record<string, any>) => loginStatus.oneOf(perm);
};

/**
 * 多个权限同时都有
 * @param perm
 * @return {*}
 */
export const allOf = (perm: any) => {
  if (!perm) {
    return undefined;
  }
  return (loginStatus: Record<string, any>) => loginStatus.allOf(perm);
};

export const combineAndPerm = (oneOfPerm: any, allOfPerm: any) => {
  if (!oneOfPerm) {
    return undefined;
  }
  if (!allOfPerm) {
    return undefined;
  }
  return (loginStatus: Record<string, any>) => loginStatus.oneOf(oneOfPerm) && loginStatus.allOf(allOfPerm);
};

export const combineOrPerm = (oneOfPerm: any, allOfPerm: any) => {
  if (!oneOfPerm) {
    return undefined;
  }
  if (!allOfPerm) {
    return undefined;
  }
  return (loginStatus: Record<string, any>) => loginStatus.oneOf(oneOfPerm) || loginStatus.allOf(allOfPerm);
};

// is_creative_assets_enable 已全量上线，角色白名单用于 perm 控制
const CREATIVE_ASSETS_ENABLED_ROLE_IDS = [
  ROLES_NAME_TO_ID.OPERATORROLE_ADMIN,
  ROLES_NAME_TO_ID.OPERATORROLE_AGENT_OPERATOR,
  ROLES_NAME_TO_ID.AGENCYOPERATORROLE_AGENCY_BOSS,
  ROLES_NAME_TO_ID.AGENCYOPERATORROLE_AGENCY_ADMIN,
  ROLES_NAME_TO_ID.AGENCYOPERATORROLE_AGENCY_OPERATOR,
  ROLES_NAME_TO_ID.AGENCYOPERATORROLE_MDM_BOSS,
  ROLES_NAME_TO_ID.AGENCYOPERATORROLE_MDM_ADMIN,
  ROLES_NAME_TO_ID.AGENCYOPERATORROLE_AGENCY_MDM_OPERATOR,
  ROLES_NAME_TO_ID.AGENCYOPERATORROLE_AGENCY_SUB_ADMIN,
  ROLES_NAME_TO_ID.AGENCYOPERATORROLE_AGENCY_DESIGNER, // 设计师
];

/**
 * 是否拥有 Creative+ 导航角色白名单权限
 */
export const hasCreativeAssetsEnabledRole = (loginStatus: Record<string, any>) => {
  const roleList = loginStatus?.role_list || {};
  return CREATIVE_ASSETS_ENABLED_ROLE_IDS.some((id) => roleList[id]);
};

/**
 * is_creative_assets_enable 已全量上线，恒为启用态，仅保留角色白名单判断
 */
export const isCreativeAssetsEnable = (loginStatus: Record<string, any>) => {
  return hasCreativeAssetsEnabledRole(loginStatus);
};
